// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__rMh5q","introSec":"styles_introSec__llT0A","ttl1":"styles_ttl1__yJy-e","txt1":"styles_txt1__7QKGj"};